import React from "react";

import "./index.scss"
import {} from "../../api/index"
export class MyTable extends React.Component{
    constructor(props){
        super(props);
        this.state={
            
        }
        
    }
    
    static defaultProps = {
        tableHeadData:[],
        tableBodyData:[]
    }
    scrolls(){
        console.log(123);
    }
    render(){
        
        return(
            <div className="Mytable" style={this.props.style} onScroll={()=>{this.scrolls()}}>
                {
                     this.props.children
                 }
            </div>
            
        )
    }
    componentDidMount(){
        
        function getScrollTop() {
            var scrollTop = 0;
            if(document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop;
            } else if(document.body) {
                scrollTop = document.body.scrollTop;
            }
            return scrollTop;
        }
        
    }
}

export class MyTableHead extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return (
            <div className="MyTableHead">
                {
                     this.props.children
                 }
            </div>
        )
    }
}
export class MyTableTr extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return (
            <div className="MyTableTr">
                {
                     this.props.children
                 }
            </div>
        )
    }
}
export class MyTableTh extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return (
            <div  className="MyTableTh" style={this.props.style||{}}>
                {
                     this.props.children
                 }
            </div>
        )
    }
    
}
export class MyTableTd extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return (
            <div className="MyTableTd">
                {
                     this.props.children
                 }
            </div>
        )
    }
}
export class MyTableBody extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return (
            <div className="MyTableBody">
                {
                     this.props.children
                 }
            </div>
        )
    }
}
